import { computed, getCurrentInstance } from "vue";
import { createI18n } from "vue-i18n";

export const pluralizationRules = {
  cs: (choice) => {
    if (choice === 1) {
      return 0;
    }
    if (choice >= 2 && choice <= 4) {
      return 1;
    }
    return 2;
  },
};

export const i18n = createI18n({
  legacy: true,
  globalInjection: true,
  locale: "en",
  fallbackLocale: "en",
  silentTranslationWarn: true,
  silentFallbackWarn: true,
  pluralizationRules,
});

/**
 * Translation helper for <script setup> while the app uses legacy i18n mode.
 *
 * Legacy mode installs `$t`/`$i18n` in a `beforeCreate` mixin, which runs AFTER
 * `setup()`, so they are not available on the proxy at setup time. We therefore
 * resolve `$t` lazily at call time (render/computed), where the component's
 * legacy VueI18n instance is ready and local <i18n> blocks are merged in.
 * Falls back to `i18n.global` outside a component (e.g. tests).
 */
export function useAppI18n() {
  const instance = getCurrentInstance();
  if (instance) {
    const proxy = instance.proxy;
    return {
      t: (...args) => proxy.$t(...args),
      locale: computed(() => proxy.$i18n.locale),
    };
  }
  const { t, locale } = i18n.global;
  return { t, locale };
}
